module.exports = "https://static.wanderu.com/static/media/time.9ebb58b9.png";